import styled from 'styled-components';

export const RiskBadgeContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;
	width: 100%;
`;

export const RiskBadgeContent = styled.span`
	border-radius: 0.25rem;
	border: 2px solid #2f54eb;
	background-color: #E6EAF8;
	color: #2f54eb;0
	font-weight: 600;
	font-style: semibold;
	font-size: 21px;
	padding: 0.0rem 0.7rem;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	gap: 0.5rem;
	width: 100%;
`;
